module.exports = __webpack_public_path__ + "img/xp-tb-scratchcards.59517b7.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/gamification/xp-tb-scratchcards.png
// module id = Nqyk
// module chunks = 38 43